<template>
  <ForieLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <div
    class="contaienr-fluid page-header"
    :style="{
      'background-image': `url(${this.$store.state.homePageImageV})`,
    }"
    v-if="this.$store.state.homePageImageV != ''"
  >
    <div class="container">
      <div class="head-text">
        <h1 class="head-text-title">
          {{ companyName }}
        </h1>
        <p class="head-text-p">
          {{ this.$store.getters.getWordLocale("txt_ihract_urunleri") }}:
          {{ companyKeywords.split(",").join(" , ").substr(0, 800) }}
        </p>
      </div>
    </div>
  </div>

  <div
    v-else
    class="contaienr-fluid page-header"
    :style="{
      'background-image':
        'url(' + require('/src/assets/img/header-page-background.svg') + ')',
    }"
  >
    <div class="container">
      <div class="head-text">
        <h1 class="head-text-title">
          {{ companyName }}
        </h1>
        <p class="head-text-p">
          {{ this.$store.getters.getWordLocale("txt_ihract_urunleri") }}:
          {{ companyKeywords.split(",").join(" , ").substr(0, 800) }}
        </p>
      </div>
    </div>
  </div>

  <div class="container-fluid about-us-cf-box">
    <div class="container about-us-content">
      <h3>
        {{ toTitles(this.$store.getters.getWordLocale("txt_hakkimizda")) }}
      </h3>
      <p>
        {{ companyDescription }}
      </p>
      <div class="row">
        <div
          v-if="this.$store.state.homePageAboutUsImageV != ''"
          class="about-us-card-images col-12 align-items-center d-flex mb-2 col-md-8"
        >
          <img :src="this.$store.state.homePageAboutUsImageV" />
        </div>
        <div
          v-else
          class="about-us-card-images col-12 col-md-8 align-items-center d-flex mb-2"
        >
          <img :src="require(`/src/assets/img/about-us.png`)" />
        </div>
        <div class="about-us-information col-12 col-md-4">
          <div class="about-us-information-card">
            <span
              ><i class="far fa-user-circle"></i
              ><abbr>{{
                toTitles(this.$store.getters.getWordLocale("txt_yetkili"))
              }}</abbr></span
            >
            <abbr>{{ contactPerson }}</abbr>
            <span>{{ companyAddress }}</span>
            <span>{{ phone }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!removeProductsSection" class="container-fluid product-cf-box">
    <div class="container">
      <div class="product-slider-text">
        <h3>{{ this.$store.getters.getWordLocale("txt_urunler") }}</h3>
        <p>
          {{ companyName }} /
          {{
            countryName.length > 10
              ? `${countryName.substr(0, 10)}...`
              : countryName
          }}

          {{
            this.$store.getters.getWordLocale(
              "txt_urtilen_iharacat_edilen_urunler"
            )
          }}
        </p>
      </div>
      <Carousel :settings="settings" :breakpoints="breakpoints">
        <Slide v-for="(product, index) in companyProducts" :key="index">
          <div class="carousel__item">
            <router-link
              class="product-item"
              :to="
                '/' +
                this.$store.state.langCodeX +
                '/' +
                product.productLink +
                '/' +
                this.$store.state.singleCompanyUrlNameX
                  .split(`-`)
                  .slice(0, 3)
                  .join(`-`) +
                '/' +
                this.$store.state.singleCompanyUrlCountryX +
                '/export-products'
              "
            >
              <img
                class="w-100"
                :title="product.fullTitle"
                :src="'https://cdn.turkishexporter.com.tr' + product.image"
                alt=""
              />
            </router-link>

            <small :title="product.fullTitle">{{ product.title }}</small>
          </div>
        </Slide>

        <template #addons>
          <div class="sider-btn">
            <Navigation />
          </div>
        </template>
      </Carousel>
    </div>

    <div
      class="d-flex align-item-center justify-content-center all-product-btn-box"
    >
      <router-link
        class="btn all-product-btn"
        :to="'/' + this.$store.state.langCodeX + '/products'"
        >{{ this.$store.getters.getWordLocale("txt_tum_urunler") }}</router-link
      >
    </div>
    <div class="container">
      <div class="product-keyowrd-list">
        <a
          v-for="(pKeyword, ki) in productsKeywords"
          :key="ki"
          href="javascript:;"
          ><i class="material-icons-outlined">label</i>
          <span>{{ pKeyword }}</span></a
        >
      </div>
    </div>
  </div>

  <CompanyKeywords
    :companyName="companyName"
    :companyKeywords="companyKeywords != '' ? companyKeywords.split(',') : []"
  />
</template>

<script>
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

import { defineComponent } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";
import CompanyKeywords from "./components/CompanyKeywords.vue";

export default defineComponent({
  name: "Breakpoints",
  components: {
    ForieLoader,
    TeLoader,
    CompanyKeywords,
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      removeProductsSection: false,
      showLoader: true,
      countryName: "",
      productsKeywords: [],
      companyProducts: [
        {
          image: "/storage/images/general/no-image.png",
          title: "",
          description: "",
        },
      ],
      companyAddress: "",
      contactPerson: "",
      phone: "",
      companyName: "",
      companyDescription: "",
      companyKeywords: "",
      userId: 0,
      userDetails: [],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 0.5,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  methods: {
    async getCompanyInformation() {
      var result = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: this.$store.state.singleCompanyIdX,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullInfoX = result;
      result.CompanyContactInformations.forEach((element) => {
        var address = element.Address;
        if (this.companyAddress == "") {
          this.companyAddress = address;
        }
        if (this.contactPerson == "") {
          this.contactPerson = element.ContactPearson;
        }

        element.Phones.forEach((tel) => {
          if (this.phone == "") {
            this.phone = tel;
          }
        });
      });
    },
    buildCompanyInfo() {
      this.$store.state.singleCompanyFullInfoX.CompanyContactInformations.forEach(
        (element) => {
          var address = element.Address;
          if (this.companyAddress == "") {
            this.companyAddress = address;
          }
          if (this.contactPerson == "") {
            this.contactPerson = element.ContactPearson;
          }

          element.Phones.forEach((tel) => {
            if (this.phone == "") {
              this.phone = tel;
            }
          });
        }
      );
    },
    async getCompanyProducts() {
      var companies = [this.$store.state.singleCompanyIdX];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 1000,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyProducts = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullProductsX = this.companyProducts;
      this.buildCompanyProducts(this.companyProducts);
    },
    buildCompanyProducts(variable) {
      var temp = [];
      if (variable.length > 0) {
        variable = variable[0].Products;
        var count = 0;
        variable.forEach((product) => {
          if (count > 6) {
            return;
          }
          if (product.Images.length > 0) {
            var id = parseInt(product.Images[0]._id);
            var image = product.Images[0].Image;
            var title =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;

            var fullTitle = title;
            title = title.length > 15 ? `${title.substr(0, 15)}...` : title;

            var description =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Description
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Description;

            var keywords =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Keywords
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Keywords;

            if (keywords != "" && keywords != undefined) {
              keywords.split(",").forEach((k) => {
                this.productsKeywords.push(k);
              });
            }

            var productLink = `${fullTitle
              .toLowerCase()
              .trim()
              .split(" ")
              .join("-")}-${id}`;

            productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
            productLink = productLink.replace(/---/g, "-");
            productLink = productLink.replace(/--/g, "-");

            temp.push({
              image: image,
              title: title,
              fullTitle: fullTitle,
              description: description,
              productLink: productLink,
            });
            count++;
          }
        });

        if (temp.length > 0) {
          this.companyProducts = [];
          this.companyProducts = temp;
        } else {
          this.removeProductsSection = true;
        }
      }

      this.showLoader = false;
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
  },
  mounted() {
    this.showLoader = true;
    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    if (this.$store.state.langCodeX != "tr") {
      this.companyName = this.companyName.replace(/ı/g, "i");
    }

    this.countryName =
      this.$store.state.singleCompanyDetailsX.Country.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.companyDescription =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) =>
          q.LangCode == this.$store.state.langCodeX &&
          q.DescriptionContent != null
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].DescriptionContent
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].DescriptionContent;

    this.fullDescription = this.companyDescription.length >= 250 ? false : true;

    this.companyKeywords =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Keywords
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Keywords;

    this.userId = parseInt(this.$store.state.singleCompanyDetailsX.rlt_User_Id);

    if (this.$store.state.singleCompanyFullInfoX.length == 0) {
      this.getCompanyInformation();
    } else {
      this.buildCompanyInfo();
    }

    if (this.$store.state.singleCompanyFullProductsX.length == 0) {
      this.getCompanyProducts();
    } else {
      this.buildCompanyProducts(this.$store.state.singleCompanyFullProductsX);
    }
  },
});
</script>


<style scoped>
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--m3--sys--light--background);
  color: rgb(0, 0, 0);
  font-size: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 10px;
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}
.carousel__item small {
  display: flex;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  margin-top: 16px;
  margin-left: 16px;
  margin-bottom: 16px;
  color: var(--m3--sys--light--on-surface);
}

@import "./style.css";
</style>